import { Injectable } from '@angular/core';
import { ModelService } from '../../../shared/services/model.service';
import { Task } from './task.model';
import * as _ from 'lodash';
import { switchMap, map } from 'rxjs/operators';
import { ApiHttpClient } from 'app/http/clients/api';
import { TaskComment } from '../task-comment/task-comment.model';
import { environment } from 'environments/environment';
import { Select } from '@ngxs/store';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { Observable } from 'rxjs';
import { LenderUser } from 'app/models/dto/lender-user.model';
import {IssueTypeCategory} from 'ng2-app/modules/task-management/models/workflow-task/issue-types.model';

@Injectable()
export class TaskService extends ModelService<Task> {

    @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;

    protected urlPath = '/task';

    private borrowerBaseUrl: string;

    constructor(http: ApiHttpClient) {
        super(http);

        this.borrowerBaseUrl = environment.API_URL + '/borrower';
    }

    complete(task: Task) {
        return this.lenderUser$.pipe(
            switchMap((currentUser) => {
                const body = {completedByUserId: currentUser.id};
                return this.http.put(`${this.endpointUrl}/${task.id}/complete`, body);
            })
        );
    }

    reOpen(task: Task) {
        return this.http.put(`${this.endpointUrl}/${task.id}/reopen`, {});
    }

    createNewComment(comment: string, taskId: number, isForLender: boolean = false) {
        return this.http.post<TaskComment>(
            `${this.endpointUrl}/${taskId}/comment`,
            {
              description : comment,
              isForLender,
            }
        );
    }

    assign(taskId: number) {
        return this.http.post(`${this.endpointUrl}/${taskId}/assign`, {});
    }

    tasksForBorrower(borrowerId: number) {
        return this.http.get<Task[]>(`${this.borrowerBaseUrl}/${borrowerId}/tasks`).pipe(
            map((tasks: any[]) => _.map(tasks, (taskJson) => this.createFromResponseData(taskJson)))
        );
    }

    getIssueTypes() {
      return this.http.get<IssueTypeCategory[]>(`${environment.API_URL}/issue-types-by-category`);
    }

    protected createFromResponseData(responseData: any): Task {
        return new Task(responseData);
    }

    protected postUrl(model: Task) {
        return `${this.borrowerBaseUrl}/${model.borrowerId}/tasks`;
    }
}
